import { FC, useMemo } from "react"
import type { ChartConfiguration } from "chart.js"
import { Chart } from "../../../../../../../Common/Lazy/Chart"
import { Color } from "../../../../../../../../Models/Client/Color"
import { format } from "date-fns/esm"
import { AIModelForApp } from "../../../../../../../../Models/API/AIModel"
import { getPredictionCountByDay } from "neql"

interface ActivityChartProps {
    isSimple: boolean
    model: AIModelForApp
}

export const ActivityChart: FC<ActivityChartProps> = ({ isSimple, model }) => {
    const activityConfig = useMemo<ChartConfiguration | undefined>(() => {
        const activity = getPredictionCountByDay(model).toArray()
        const pointColor = isSimple ? "transparent" : Color.violet

        return {
            type: "line",
            data: {
                labels: activity.map(([day], i, arr) =>
                    format(
                        new Date(day),
                        i === 0 || i === arr.length - 1 ? "d" : "d MMM"
                    )
                ),
                datasets: [
                    {
                        data: activity.map(([_, count]) => count),
                        borderWidth: isSimple ? 1 : 3,
                        borderColor: Color.violet,
                        pointBorderColor: pointColor,
                        pointBackgroundColor: pointColor,
                        lineTension: 0,
                        backgroundColor: "transparent"
                    }
                ]
            },
            options: {
                aspectRatio: isSimple ? 6 : 2,
                animation: {
                    duration: 0
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                drawTicks: false,
                                color: "transparent",
                                zeroLineColor: "#979797"
                            },
                            ticks: isSimple
                                ? { display: false }
                                : {
                                      fontColor: "#818283",
                                      padding: 10,
                                      maxTicksLimit: 2
                                  }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                drawTicks: false,
                                color: "transparent",
                                zeroLineColor: "#979797"
                            },
                            ticks: isSimple
                                ? { display: false }
                                : {
                                      fontColor: "#818283",
                                      stepSize: 1,
                                      beginAtZero: true,
                                      padding: 10,
                                      maxTicksLimit: 5
                                  }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                layout: {
                    padding: isSimple ? 8 : undefined
                },
                plugins: {
                    datalabels: {
                        labels: {
                            title: null
                        }
                    }
                },
                maintainAspectRatio: !isSimple,
                responsive: true,
                tooltips: {
                    enabled: !isSimple
                }
            }
        }
    }, [isSimple, model])

    return <Chart config={activityConfig} />
}
